import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Tooltip } from './Tooltip'

const Badge = styled.sup`
  font-family: 'Rubik', sans-serif;
  vertical-align: top;
  position: relative;
  user-select: none;
  top: -0.5em;
  margin-left: 4px;
  text-transform: uppercase;
  font-weight: 500;
  ${Fonts.colors.Cobalt};
  border: 1px solid ${Colors.Cobalt};
  padding: 1px;
  border-radius: 4px;
  font-size: 10px;
`

const BaseBetaBadge = () => (
  <Tooltip offset={8} reposition title={'This feature is still in development. Please use with caution and help us by reporting any bugs.'}>
    <Badge>beta</Badge>
  </Tooltip>
)

export const BetaBadge = styled(BaseBetaBadge)``
